export const BASE_URL = process.env.REACT_APP_API_BASEURL;
export const TEMP_TOKEN = process.env.TEMP_TOKEN_TEMP;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
